/**
 * Hakumodeli tarjouskaupan hakusivua varten.
 * Toimii ns. intermediatena hakusivun kontrollerin ja hakupalkin kontrollerin välillä, jotka
 * ei hierarkiassa ole välttämättä toistensa sisällä.
 */
app.factory("OnlineOfferSearchModel",
	["$http", "$timeout", "$rootScope", "OnlineOfferSearchService", function($http, $timeout, $rootScope, OnlineOfferSearchService) {

		var self = this;

		/**
		 * Hakuparametrit.
		 */
		//this.query = OnlineOfferSearchService.CreateQuery();

		this.queries = {};

		return this;

	}]
);
